import flatpickr from "flatpickr";

export default class CapeCalendar {

    constructor() {
        this.init();
        this.initEventsListener();
    }

    init() {
        $(document).ready(() => {
            if (window.flatpickrinstance && typeof window.flatpickrinstance.destroy === "function") window.flatpickrinstance.destroy();
            let form = $('form.event-list-filters');

            form.find('input[name="start_date"]').val('');
            form.find('input[name="end_date"]').val('');

            window.flatpickrinstance = flatpickr("#events-calendar input", {
                'inline': true,
                monthSelectorType: 'static',
                minDate: Date.now(),
                onValueUpdate: (selectedDates, dateStr, instance) => {
                    form.find('select[name="category"]').val('');
                    form.find('select[name="language"]').val('');
                    form.find('select[name="month"]').val('');

                    form.find('input[name="start_date"]').val(dateStr);
                    form.find('input[name="end_date"]').val(dateStr);

                    form.submit();
                    this.calendarMarkers(instance.currentMonth, instance.currentYear);
                },

                onReady: (selectedDates, dateStr, instance) => {
                    this.calendarMarkers(instance.currentMonth, instance.currentYear);
                },

                onChangeMonth: (selectedDates, dateStr, instance) => {
                    this.calendarMarkers(instance.currentMonth, instance.currentYear);
                },

                enable: [
                    () => {
                        return false;
                    }
                ],

                onDayCreate: (dObj, dStr, instance, dayElem) => {
                    function get2DigitFmt(val) {
                        return ('0' + val).slice(-2);
                    }


                    let date = dayElem.dateObj,
                        key = date.getFullYear() + '-' + get2DigitFmt(date.getMonth() + 1) + '-' + get2DigitFmt(date.getDate());

                    let $eventDate = $("<span class='event-day' data-day='" + key + "'>");
                    $(dayElem).append($eventDate);
                },

            });
        });

    }

    initEventsListener() {
        let $body = $('body');

        $body.off('click', '#events-calendar .flatpickr-next-month, #events-calendar .flatpickr-prev-month, #events-calendar .arrowUp, #events-calendar .arrowDown').on('click', '.flatpickr-next-month, .flatpickr-prev-month, .arrowUp, .arrowDown', () => {
            this.calendarMarkers(window.flatpickrinstance.currentMonth, window.flatpickrinstance.currentYear);
        });

        $body.off('click', '#events-calendar .flatpickr-day:not(.active)').on('click', '.flatpickr-day:not(.active)', (e) => {
            e.preventDefault();
            e.stopPropagation();

            return false;
        });


        $body.on('input change', '#events-calendar .cur-year', () => {
            this.calendarMarkers(window.flatpickrinstance.currentMonth, window.flatpickrinstance.currentYear);
        });


        // window.addEventListener('load', () => {
        //     if (window.innerWidth < 1250 ) {
        //         $('.events').addClass('closed')
        //     } else {
        //         $('.events').removeClass('closed')
        //     }
        // })
        

        // window.addEventListener('resize', () => {
        //     if (window.innerWidth < 1250 ) {
        //         $('.events').addClass('closed')
        //     } else {
        //         $('.events').removeClass('closed')
        //     }
        // })

        $body.on('click', '#event-list-calendar', () => {
            $('.events').removeClass('closed');
            $('.container-content').css({'margin': '0 0 0 20px'})
            $('.block-event').removeClass('col-12 col-md-6 col-xlg-4 col-xl-3')
            $('.block-event').addClass('col-12 col-sm-10 col-md-8 col-xlg-6 col-lg-4 col-xl-3')

            if ($(window).width() <= 1000) {
                $('.container-content').css({'max-width': 'calc(100% - 120px)'})
            } else {
                $('.container-content').css({'max-width': 'calc(100% - 200px)'})
            }

        });

        $body.on('click', '.event-list-calendar_close', (e) => {
            e.stopPropagation();
            $('.events').addClass('closed');
            $('.container-content').css({'max-width': '90vw'})
            $('.container-content').css({'margin': '0 auto'})
            $('.block-event').removeClass('col-12 col-sm-10 col-md-8 col-xlg-6 col-lg-4 col-xl-3')
            $('.block-event').addClass('col-12 col-md-6 col-xlg-4 col-xl-3')
        });
    }

    calendarMarkers(month, year) {
        this.request = $.request('onGetMonthEvents', {
            data: {
                'month': month + 1,
                'year': year,
            },

            success: (data) => {
                $.each(data, (i, event) => {

                    $.each(event.event.categories, (j, category) => {
                        let categoryColor = event.event.event_color;
                        let classColor = event.event.event_color.slice(1);
                        let sliceDate = event.date.slice(0, -9);

                        if (!$('.event-day[data-day="' + sliceDate + '"]').find('.' + classColor).length) {
                            let $eventsCalendar = $('#events-calendar');
                            let $element = $eventsCalendar.find('.event-day[data-day="' + sliceDate + '"]');
                            $element.append('<span class="event-day-marker ' + classColor + '" style="background: ' + categoryColor + '"></span>');
                            $element.parent().addClass('active');
                            $element.parent().removeClass('flatpickr-disabled');
                        }
                    });
                });
            }
        });
    }


}
